import { CurrencyCode } from "@domain/currency/currency";
import { LANGUAGE, LANGUAGES } from "./language";

export const currencyFormater = (n: number, currencyCode: CurrencyCode, language?: LANGUAGE): string => {
	const lang = language ? LANGUAGES[language] : navigator.language;

	try {
		return new Intl.NumberFormat(lang, { style: "currency", currency: currencyCode }).format(n);
	} catch {
		return "";
	}
};
